import * as Sentry from "@sentry/react";

export const setSentryUser = (accountEmail: string) => {
  Sentry.setUser({ id: accountEmail });
};

export const clearSentryUser = () => {
  Sentry.configureScope((scope) => scope.setUser(null));
};
